import React, { PureComponent } from 'react';
import { withLocalize } from 'react-localize-redux';
import styled from 'styled-components';

import TitledSection from '../../components/titled-section';
import QandAList from '../../containers/q-and-a-list';
import jaLocale from './ja.locale.js';

const PaddedContainer = styled.div`
  padding: 0 1em;

  @media (max-width: 767px) {
    padding-bottom: 1.5em;
  }
`;

/**
 * FAQ component
 */
class FAQPage extends PureComponent {
  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }

  render() {
    const {
      pageContext: { gameId }
    } = this.props;

    const paths = gameId
      ? [`/faqs/gameSpecific/${gameId}`, `/faqs/general`]
      : [`/faqs/general`];

    return (
      <TitledSection subtitleId="faqPage.subtitle" titleId="faqPage.title">
        <PaddedContainer>
          <QandAList paths={paths} />
        </PaddedContainer>
      </TitledSection>
    );
  }
}

export default withLocalize(FAQPage);
